module.exports = __webpack_public_path__ + "static/img/10.ea8b7f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/10.png
// module id = ISHP
// module chunks = 0